/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchNotificationsResponseNotifications,
  FetchNotificationsResponseNotificationsFromJSON,
  FetchNotificationsResponseNotificationsToJSON,
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchNotificationsResponse
 */
export interface FetchNotificationsResponse {
  /**
   * A list of notifications available to be edited by admins.
   * @type {Array<FetchNotificationsResponseNotifications>}
   * @memberof FetchNotificationsResponse
   */
  notifications: Array<FetchNotificationsResponseNotifications>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchNotificationsResponse
   */
  pagination?: PaginationResponse
}

export function FetchNotificationsResponseFromJSON(
  json: any
): FetchNotificationsResponse {
  return FetchNotificationsResponseFromJSONTyped(json, false)
}

export function FetchNotificationsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchNotificationsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    notifications: (json['notifications'] as Array<any>).map(
      FetchNotificationsResponseNotificationsFromJSON
    ),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchNotificationsResponseToJSON(
  value?: FetchNotificationsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    notifications: (value.notifications as Array<any>).map(
      FetchNotificationsResponseNotificationsToJSON
    ),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
